"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TriggerContent = exports.TooltipItem = exports.ArrowWithBorder = void 0;
var _react = _interopRequireDefault(require("react"));
var RadixTooltip = _interopRequireWildcard(require("@radix-ui/react-tooltip"));
var _Text = _interopRequireDefault(require("../../text/Text"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Tooltip = require("./Tooltip.styled");
var _globalTokens = require("../../../shared/global-tokens");
var _Subheading = _interopRequireDefault(require("../../text/Subheading"));
var _FlexColumn = require("../../layout/flex/FlexColumn");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _jsxRuntime = require("react/jsx-runtime");
var TOOLTIP_WIDTH = {
  s: 's',
  m: 'm',
  l: 'l',
  xl: 'xl'
};
var TriggerContent = exports.TriggerContent = _styledComponents.default.div.withConfig({
  displayName: "Tooltip__TriggerContent",
  componentId: "sc-1tih3kw-0"
})(["width:fit-content;"]);
var ArrowWithBorder = exports.ArrowWithBorder = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", _objectSpread({
    viewBox: "0 0 30 10"
  }, props, {
    ref: ref,
    fill: 'white',
    width: _globalTokens.globalSizing['400'],
    height: _globalTokens.globalSizing['200'],
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M0,0 L15,10 L30,0",
      stroke: _globalTokens.globalColor.border.separator,
      strokeWidth: "2"
    })
  }));
});
var TooltipItem = function TooltipItem(_ref) {
  var title = _ref.title,
    details = _ref.details,
    content = _ref.content;
  var renderedTitle = (content === null || content === void 0 ? void 0 : content.title) || title;
  var renderedContent = (content === null || content === void 0 ? void 0 : content.details) || details;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FlexColumn.FlexColumn, {
    gap: 's',
    children: [renderedTitle && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Subheading.default, {
      children: renderedTitle
    }), renderedContent && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
      children: renderedContent
    })]
  });
};
exports.TooltipItem = TooltipItem;
var Tooltip = function Tooltip(_ref2) {
  var content = _ref2.content,
    interactable = _ref2.interactable,
    children = _ref2.children,
    width = _ref2.width,
    onOpenChange = _ref2.onOpenChange;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(RadixTooltip.Provider, {
    delayDuration: 400,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(RadixTooltip.Root, {
      onOpenChange: onOpenChange,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(RadixTooltip.Trigger, {
        asChild: true,
        onClick: function onClick(event) {
          if (!interactable) {
            event.preventDefault();
          }
        },
        children: interactable ? children : /*#__PURE__*/(0, _jsxRuntime.jsx)(TriggerContent, {
          tabIndex: 0,
          children: children
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(RadixTooltip.Portal, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Tooltip.TooltipContent, {
          width: width,
          sideOffset: 5,
          onPointerDownOutside: function onPointerDownOutside(event) {
            if (!interactable) {
              event.preventDefault();
            }
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
            children: content
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(RadixTooltip.Arrow, {
            asChild: true,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ArrowWithBorder, {})
          })]
        })
      })]
    })
  });
};
Tooltip.WIDTH = TOOLTIP_WIDTH;
Tooltip.Item = TooltipItem;
Tooltip.Item.propTypes = {
  title: _propTypes.default.string,
  details: _propTypes.default.string,
  /**
   * In webfront we often pass around tooltips as title / details objects, so this is a convenience prop to allow that
   * */
  content: _propTypes.default.shape({
    title: _propTypes.default.string,
    details: _propTypes.default.string
  })
};
Tooltip.defaultProps = {
  width: TOOLTIP_WIDTH.m,
  interactable: true,
  iconSize: 'm'
};
var _default = exports.default = Tooltip;